module.exports = __webpack_public_path__ + "static/media/axis_of_polarization_00238.a3df31b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/hdpolarized/axis/en/axis_of_polarization_00238.png
// module id = 968
// module chunks = 0